import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Clock, Plus, ChevronRight } from 'lucide-react';
import { format, addDays } from 'date-fns';

interface ClientScheduleProps {
  clientId: string;
}

export function ClientSchedule({ clientId }: ClientScheduleProps) {
  const schedule = [
    {
      id: 1,
      date: new Date(),
      time: '10:30 AM',
      type: 'Strength Training',
      duration: 60
    },
    {
      id: 2,
      date: addDays(new Date(), 2),
      time: '2:00 PM',
      type: 'HIIT Session',
      duration: 45
    },
    {
      id: 3,
      date: addDays(new Date(), 4),
      time: '11:00 AM',
      type: 'Recovery Session',
      duration: 30
    }
  ];

  return (
    <div className="theme-card p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Calendar className="w-5 h-5 text-primary" />
          <h2 className="text-lg font-semibold">Upcoming Sessions</h2>
        </div>
        <button className="theme-button px-3 py-1.5 rounded-lg text-sm flex items-center gap-1">
          <Plus className="w-4 h-4" />
          Schedule Session
        </button>
      </div>

      <div className="space-y-4">
        {schedule.map((session, index) => (
          <motion.div
            key={session.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-muted/30 p-4 rounded-lg group hover:bg-muted/50 transition-colors cursor-pointer"
          >
            <div className="flex items-center justify-between">
              <div>
                <div className="font-medium">{session.type}</div>
                <div className="flex items-center gap-4 text-sm text-muted-foreground">
                  <div className="flex items-center gap-1">
                    <Calendar className="w-3 h-3" />
                    <span>{format(session.date, 'MMM d, yyyy')}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Clock className="w-3 h-3" />
                    <span>{session.time}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Clock className="w-3 h-3" />
                    <span>{session.duration} min</span>
                  </div>
                </div>
              </div>
              <ChevronRight className="w-5 h-5 text-primary opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}